import { isMobile } from '../utils/constants';

const os = ['Windows', 'Linux', 'Mac', 'X11'];
const currentOs = os.find((v) => navigator.userAgent.indexOf(v) >= 0);

if (currentOs === 'Windows') {
	document.body.classList.add('windows');
} else if (currentOs === 'Mac') {
	document.body.classList.add('mac');
}

export const addClasses = () => {
	const inputList = document.querySelectorAll('.form-group .form-control');

	if (inputList.length) {
		inputList.forEach((input) => {
			input.addEventListener('focus', (event: any) => {
				event.target.classList.add('focus');
			});

			const handleInputChange = (event: any) => {
				if (event.target.value !== '') {
					event.target.classList.add('active');
				} else {
					event.target.classList.remove('active');
				}

				input.removeEventListener('change', handleInputChange);
			};

			input.addEventListener('change', handleInputChange);

			input.addEventListener('blur', (event: any) => {
				event.target.classList.remove('focus');
				if (event.target.value !== '') {
					event.target.classList.add('active');
				} else {
					event.target.classList.remove('active');
				}
			});
		});
	}
};

export const tabClickEvents = () => {
	document.body.addEventListener('keydown', function (event) {
		if (event.keyCode === 9) {
			document.body.classList.add('tab-key-press');
		}
	});

	document.body.addEventListener('mousedown', function () {
		document.body.classList.remove('tab-key-press');
	});
};

export const pinchzoom = () => {
	if (!isMobile) {
		document.body.classList.add('desk-pinchzoom');
	}
};
